import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Table} from 'react-bootstrap'
import { deflate } from 'zlib';

class UserDetail extends Component {
    render(){
        return <div>
            {this.props.selectedUser ? this.props.selectedUser['firstName'] : ''}
        </div>
    }
}

const mapStateToProps = state => (
    {
        selectedUser : state.acct.user.selectedUser,
  });

  export default connect(mapStateToProps)(UserDetail)